<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag size="mini" :type="row.isActive === 'Y' ? 'light' : 'warning'">
          {{ row.v_isActive }}
        </el-tag>
      </template>

      <template v-slot:growthmode="{ row }">
        {{ row.v_isAddType }}
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.serialName
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.serialName
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.isActive === 'Y'"
            v-if="allow('D')"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.serialName)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq'
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 110,
          slots: {
            default: 'opt'
          }
        },
        {
          title: this.$l('table_label_serial_number_name') || '流水号名称',
          field: 'serialName',
          headerAlign: 'center',
          minWidth: 170,
          align: 'left',
          fixed: 'left',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('table_label_serial_number_type') || '流水号类型',
          field: 'serialType',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('table_label_special_prefix') || '特殊前缀',
          field: 'specialPrefix',
          minWidth: 80,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('table_label_documents_prefix') || '单据前缀',
          field: 'billPrefix',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('table_label_date_format') || '日期格式',
          field: 'dateType',
          minWidth: 100,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          headerAlign: 'center',
          field: 'numberLength',
          title: this.$l('table_label_serial_number_length') || '流水号长度',
          align: 'center',
          minWidth: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('table_label_growth_pattern') || '增长方式',
          minWidth: 100,
          align: 'center',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          slots: { default: 'growthmode' }
        },
        {
          headerAlign: 'center',
          field: 'currentNo',
          title: this.$l('form_label_the_current_number') || '当前编号',
          align: 'center',
          minWidth: 100,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          title: this.$l('INDEX.table_label_State') || '状态',
          width: 80,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          headerAlign: 'center',
          slots: { default: 'status' }
        },
        {
          headerAlign: 'center',
          field: 'totalLength',
          title: this.$l('table_label_serial_number_sum_length') || '总长度',
          minWidth: 80,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          headerAlign: 'center',
          field: 'currentDate',
          title: this.$l('table_label_serial_number_date') || '流水号生成日期',
          minWidth: 170,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        },
        {
          headerAlign: 'center',
          field: 'serialDescription',
          title: this.$l('table_label_serial_number_explain') || '流水号说明',
          minWidth: 250,
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis'
        }
      ]
    }
  },
  methods: {
    del(serialName) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api.sysSerialNoRuleDelApi({ serialName }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success'
          })
          this.$emit('reload')
        })
      })
    }
  }
}
</script>
